import { createSelector } from 'reselect';
import { IApplicationState } from '@bridebook/web/lib/types';

const getMultiShowroundState = (state: IApplicationState) => state.multiShowround;

export const getMultiShowroundEntryParams = createSelector(
  getMultiShowroundState,
  (state) => state.entryParams,
);
